import React from 'react'
import styles from './RowDeal.module.scss'
import ActionMenu from 'components/UI/ActionMenu/ActionMenu'
import { checkPermList } from 'helpers'
import { permissions } from '../../../../settings/permissions'
import { Link } from 'react-router-dom'

const RowDeal = ({ deal, index, action, translate }) => {
  const menu = [
    ...(checkPermList(permissions.edit_deferred_deals_crm)
      ? [
          {
            name: translate.edit,
            action: 'edit',
          },
        ]
      : []),
    ...(checkPermList(permissions.delete_deferred_deals_crm)
      ? [
          {
            name: translate.delete,
            action: 'delete',
          },
        ]
      : []),
  ]

  const hasAnyPermission =
    checkPermList(permissions.edit_deferred_deals_crm) ||
    checkPermList(permissions.delete_deferred_deals_crm)

  return (
    <>
      <div
        className={`${styles.clientContainer} ${index % 2 === 0 ? styles.colorBg : ''} `}
      >
        <div className={styles.containerInf}>
          <div className={`${styles.infStyl} ${styles.name} `}>
            <div className={styles.label}>Имя сделки:</div>
            <div className={styles.info}>
              <Link
                target='_blank'
                to={`/crm/customer-card/${deal?.deal.id}/?funnel_id=${deal.funnel.id}`}
              >
                {deal?.deal.deal_name}
              </Link>
            </div>
          </div>
          <div className={`${styles.infStyl} ${styles.name} `}>
            <div className={styles.label}>Название воронки:</div>
            <div className={styles.info}>{deal?.funnel.name}</div>
          </div>
          <div className={`${styles.infStyl} ${styles.name} `}>
            <div className={styles.label}>Отложена до:</div>
            <div className={styles.info}>{deal?.deferred_until}</div>
          </div>
          {hasAnyPermission && (
            <div className={styles.buttons}>
              <ActionMenu menu={menu} action={action} items={deal} />
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default RowDeal
